import React from "react";
import "./../index.css";

const Footer = () => {
  return (
    <div className="footer-container">
      <h2>
        Developer :{" "}
        <a
          href="https://github.com/developer-junaid"
          rel="noopener noreferrer"
          target="_blank"
        >
          Hasan Sattar
        </a>{" "}
      </h2>
    </div>
  );
};

export default Footer;
